import React from "react";
import "./ToolsPage.css";
import { Link } from "react-router-dom";

function ToolsPage() {
  return (
    <div className="tools-container">
      <h1 className="tools-title">AI Tools Dashboard</h1>
      <p>Select a premium AI tool to begin.</p>

      <div className="tools-grid">

        {/* NEW UNIQUE AI TOOLS — NOT in sidebar */}
        <Link to="/ai-req-tests" className="tool-card">
          <h3>📝 Requirement → Test Cases</h3>
          <p>Convert user stories into structured test cases automatically.</p>
        </Link>

        <Link to="/ai-risk-based" className="tool-card">
          <h3>📊 Risk-Based Testing Advisor</h3>
          <p>AI predicts risks & prioritizes testing areas.</p>
        </Link>

        <Link to="/ai-api-designer" className="tool-card">
          <h3>🔌 API Test Designer</h3>
          <p>Generate API test scenarios, validations & Postman tests.</p>
        </Link>

        <Link to="/ai-performance-plan" className="tool-card">
          <h3>⚡ Performance Test Planner</h3>
          <p>Create load, stress & endurance plans instantly.</p>
        </Link>

        <Link to="/ai-code-review" className="tool-card">
          <h3>🧠 Automation Code Review AI</h3>
          <p>Analyze Selenium or Playwright code for improvements.</p>
        </Link>

      </div>
    </div>
  );
}

export default ToolsPage;
